import { api } from '../api';

const AUTHORIZATION_VALUE_PREFIX = 'mfasession';

export interface QrCode {
  mimeType: string;
  content: string;
}

export interface MultiFactorAuthenticationGenerateResponse {
  data: {
    qr_code: QrCode;
    secret: string;
  };
}

const generate = async (authToken: string) =>
  api.post<MultiFactorAuthenticationGenerateResponse>(
    '/multiFactorAuthentication.generate',
    {},
    {
      Authorization: `${AUTHORIZATION_VALUE_PREFIX} ${authToken}`,
    },
  );

export default generate;
